import React, { useState } from 'react';
import { Col, Card } from 'react-bootstrap';
import Header from '../../Common/Header';
import RecentProfileList from './RecentProfileList';
import Searchfield from '../../Common/Searchfield';
import useSearch from '../../../hooks/index';

const RecentProfile = props => {
  const [showSearchField, setShowSearchField] = useState(false);

  const response = useSearch();

  function onSearchClear() {
    response.clearValue();
  }

  function onSearchChange(e) {
    response.setSearchValue(e.target.value);
  }

  function showOrHideSearchInput() {
    setShowSearchField(!showSearchField);
  }

  return (
    <div style={{ height: '100%' }}>
      <Col md={12} sm={12} xs={12} className={'p-2 custom-cards mobile-view leftSide-card'}>
        <Card>
          <Header
            title="Recent Deployments"
            iconPosition="justify-content-end"
            iconProps={[
              {
                toolTipKEy: 'Search',
                toolTipValue: 'Search',
                icon: 'feather icon-search',
                onClickHandler: () => showOrHideSearchInput(),
                showIcon: true,
                cursor: 'pointer',
              },
            ]}
          />
          {showSearchField ? (
            <Searchfield
              inputValue={response.searchValue}
              inputChange={e => onSearchChange(e)}
              inputClear={onSearchClear}
            />
          ) : null}
          <RecentProfileList
            useSearch={response}
            showSearchField={showSearchField}
          />
        </Card>
      </Col>
    </div>
  );
};

export default RecentProfile;
